import { useEffect, useState, useContext } from 'react';
import { useRemote, useStorage } from '../../Utils/Utils';
import { WorkflowContext } from './ActiveWorkflowsPage';
import { useWebsockets } from "../../Utils/WebsocketReceiverHook";
import Table from '../../components/Table/Table';
import UserListModal from './UserListModal';
import LoadingIcon from '../../components/LoadingIcon';
import WorkflowComplianceStepRow from './WorkflowComplianceStepRow';
import WorkflowComplianceSpotCheckRow from './WorkflowComplianceSpotCheckRow';
import "./WorkflowComplianceActions.scss";

const WorkflowComplianceActions = ({ workflowId, taskId, historical }) => {
    const { setWarnings } = useContext(WorkflowContext)
    const [data, setData] = useState(null)
    const [approversList, setApproversList] = useState([])
    const [loading, setLoading] = useState(true)

    const displayedData = data ? data : []

    const remote = useRemote()
    const storage = useStorage()
    const sockets = useWebsockets()

    useEffect(() => {
        remote.get(`workflows/workflow/${workflowId}/workflowTask/${taskId}`).then((res) => {
            checkForWarnings(res.data.data)
            setData(res.data.data);
            setLoading(false)
        })
        const socketsPath = `/api/workflow/${workflowId}/workflowTask/${taskId}`
        sockets.subscribe({
            [socketsPath]: [(message) => {
                storage.refresh(`workflows/workflow/${workflowId}/workflowTask/${taskId}`)
                    .then(res => {
                        checkForWarnings(res.data.data)
                        setData(res.data.data);
                        setLoading(false)
                    })
                    .catch((err) => {
                        console.error(err)
                        setLoading(false)
                    });
            }]
        })
        return () => {
            sockets.unsubscribe([`/api/workflow/${workflowId}/workflowTask/${taskId}`])
        }
    }, [])

    const refreshList = () => {
        remote.get(`workflows/workflow/${workflowId}/workflowTask/${taskId}`).then((res) => {
            checkForWarnings(res.data.data)
            setData(res.data.data);
        })
    }

    const stepHeaders = historical ?
        ["Action", "Approvers Req", "Approved", "Progress", ""] :
        ["Action", "Approvers Req", "Approvers Available", "Approved", "Progress","", ""]
    const stepWidths = historical ?
        ["150px", "100px", "150px", "50px", "100px", "150px" ] :
        ["150px", "100px", "150px", "70px", "100px", "150px", "50px" ]

    const stepDataMap = displayedData && displayedData.map((step, idx) => {
        switch (step.name) {
            case "Spot Check":
                return <WorkflowComplianceSpotCheckRow workflowId={workflowId} refreshList={refreshList} step={step} key={step.name + "-" + idx} idx={idx} taskId={taskId} setApproversList={setApproversList} historical={historical} />

            default:
                return <WorkflowComplianceStepRow refreshList={refreshList} step={step} key={step.name + "-" + idx} idx={idx} taskId={taskId} setApproversList={setApproversList} historical={historical} />
        }
    })

    function checkForWarnings(data) {
    if (!data || !data.map) {
        setWarnings(null)
        return
    }
        const allSteps = data.map(d => d.datas ? d.datas : []).flat()
        const foundWarnings = allSteps.filter(s => {
            if (s.responderActions?.length > 0) {
                return s.responderActions.find(a => a.status === "Pending Feedback" || a.status === "Rejected")
            } else return null
        })
        if (foundWarnings && foundWarnings.length > 0) setWarnings(foundWarnings)
        else setWarnings(null)
    }

    if (loading) {
        return (
            <>
                <LoadingIcon centered />
            </>
        )
    }

    return (
        <>
            {approversList && approversList.length > 0 && <UserListModal handleClose={() => setApproversList([])} data={approversList} />}
            <Table
                tableStyle={{ maxWidth: 1440 }}
                wrapperStyle={{ marginBottom: "6rem" }}
                colWidths={stepWidths}
                headers={stepHeaders}
                dataMap={stepDataMap}
                minWidth={1000}
            />
        </>
    )
}

export default WorkflowComplianceActions